<script setup lang="ts">
defineProps<{
  label: string;
  value: string;
  mono?: boolean;
  overriddenBy?: string | null;
}>();
</script>

<template>
  <div class="flex items-start gap-2">
    <div class="w-[104px] shrink-0 pt-1 text-[10px] font-semibold uppercase tracking-wide text-muted-foreground">
      {{ label }}
    </div>
    <div class="min-w-0 flex-1 pt-0.5">
      <code
        v-if="mono"
        class="inline-flex max-w-full rounded bg-secondary px-1.5 py-0.5 font-mono text-[10.5px] text-secondary-foreground"
      >
        <span class="truncate">{{ value }}</span>
      </code>
      <p v-else class="truncate text-[11.5px] text-foreground">{{ value }}</p>
    </div>
    <span
      v-if="overriddenBy"
      class="inline-flex shrink-0 items-center gap-1 rounded-full border px-1.5 py-0.5 text-[9.5px] font-semibold text-muted-foreground"
    >
      <Icon mode="svg" size="10" name="lucide:corner-down-right" />
      {{ overriddenBy }}
    </span>
  </div>
</template>
